var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app-container"}},[_c('nprogress-container'),_c('router-view',{key:_vm.$route.fullPath}),_c('splash-screen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }